import { HomeComponent } from './home/home/home.component';
import { PublicComponent } from './public.component';
import { VideosComponent } from './videos/videos.component';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { EventosComponent } from './eventos/eventos.component';
import { BlogComponent } from './blog/blog.component';
import { ProjetosComponent } from './projetos/projetos.component';
import { FotosDaCampanhaComponent } from './fotos-da-campanha/fotos-da-campanha.component';
import { GaleriaComponent } from './galeria/galeria.component';
import { PropostasComponent } from './propostas/propostas.component';
import { TimelineComponent } from './timeline/timeline.component';
import { BibliografiaComponent } from './bibliografia/bibliografia.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '', component: PublicComponent, children: [
      {path: '', component: HomeComponent},
      { path: 'biografia', component: BibliografiaComponent },
      { path: 'linhadotempo', component: TimelineComponent },
      { path: 'propostas', component: PropostasComponent },
      { path: 'galeria', component: GaleriaComponent },
      { path: 'fotosdacampanha', component: FotosDaCampanhaComponent },
      { path: 'projetos', component: ProjetosComponent },
      { path: 'blog', component: BlogComponent },
      { path: 'eventos', component: EventosComponent },
      { path: 'pesquisa', component: PesquisaComponent },
      { path: 'videos', component: VideosComponent }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/public-routing.module.ts